/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { delay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ToastrTranslationsNotificationService {
  constructor(private translateService: TranslateService, private toastrService: ToastrService) {}

  showNotification(translateKey: string, params = {}) {
    this.translateService
      .get(translateKey, params)
      .pipe(delay(0))
      .subscribe((res) => {
        this.toastrService.info(res);
      });
  }
}
